import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AssessmentReviewerSummaryComponent } from './assessment-reviewer-summary/assessment-reviewer-summary.component';
import { AssessmentEmailSummaryComponent } from './assessment-email-summary/assessment-email-summary.component';

const routes: Routes = [
  {
    path: '',
    component: AssessmentReviewerSummaryComponent,
  },
  {
    path: 'reviewer',
    component: AssessmentReviewerSummaryComponent,
  },
  {
    path: 'email',
    component: AssessmentEmailSummaryComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AssessmentSummaryRoutingModule { }
